document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll("[data-instagram-feed-section]");

  sections.forEach((section) => {
    const track = section.querySelector("[data-instagram-track]");
    const carousel = section.querySelector(".instagram-feed-carousel");
    if (!track || !carousel) return;

    const feedUrl = section.dataset.feedUrl || "";
    const postLimit = parseInt(section.dataset.postLimit || "12", 10);
    const showVideos = section.dataset.showVideos === "true";

    if (!feedUrl) {
      track.innerHTML = '<p class="instagram-feed-message">Instagram feed URL not configured.</p>';
      return;
    }

    fetch(feedUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
    })
      .then((res) => res.json())
      .then((json) => {
        const items = Array.isArray(json?.data) ? json.data : [];

        if (!items.length) {
          track.innerHTML = '<p class="instagram-feed-message">Instagram feed unavailable.</p>';
          return;
        }

        const filtered = items
          .filter((item) => {
            const type = (item.media_type || "").toUpperCase();
            if (showVideos) {
              return ["IMAGE", "VIDEO", "CAROUSEL_ALBUM"].includes(type);
            }
            return ["IMAGE", "CAROUSEL_ALBUM"].includes(type);
          })
          .slice(0, postLimit);

        if (!filtered.length) {
          track.innerHTML = '<p class="instagram-feed-message">No Instagram posts available.</p>';
          return;
        }

        const renderItem = (item) => {
          const type = (item.media_type || "").toUpperCase();
          const permalink = safeUrl(item.permalink, "#");
          const caption = item.caption ? escapeHtml(item.caption) : "Instagram Post";

          let mediaHtml = "";

          if (type === "VIDEO") {
            if (!showVideos) return "";
            const poster = safeUrl(item.thumbnail_url, "");
            const videoSrc = safeUrl(item.media_url, "");
            if (!videoSrc) return "";
            mediaHtml = `
              <video
                src="${videoSrc}"
                ${poster ? `poster="${poster}"` : ""}
                muted
                playsinline
                loop
                preload="metadata"
              ></video>
            `;
          } else {
            const imageSrc = safeUrl(item.media_url || item.thumbnail_url, "");
            if (!imageSrc) return "";
            mediaHtml = `<img src="${imageSrc}" alt="${caption}" loading="lazy" decoding="async">`;
          }

          return `
            <a href="${permalink}" target="_blank" rel="noopener noreferrer" class="instagram-post">
              ${mediaHtml}
            </a>
          `;
        };

        const markup = filtered.map(renderItem).filter(Boolean).join("");
        track.innerHTML = markup + markup;

        if (showVideos) {
          const videos = track.querySelectorAll("video");
          videos.forEach((video) => {
            video.play().catch(() => {});
          });
        }

        enableManualScroll(carousel);
      })
      .catch(() => {
        track.innerHTML = '<p class="instagram-feed-message">Error loading Instagram feed.</p>';
      });
  });
});

function enableManualScroll(carousel) {
  let isPointerDown = false;
  let startX = 0;
  let scrollLeft = 0;
  let moved = false;

  const pause = () => carousel.classList.add("is-paused");
  const resume = () => carousel.classList.remove("is-paused");

  carousel.addEventListener("mouseenter", pause);
  carousel.addEventListener("mouseleave", () => {
    if (!isPointerDown) resume();
  });

  carousel.addEventListener("touchstart", pause, { passive: true });
  carousel.addEventListener("touchend", () => {
    setTimeout(resume, 1200);
  }, { passive: true });

  carousel.addEventListener("pointerdown", (e) => {
    isPointerDown = true;
    moved = false;
    startX = e.pageX;
    scrollLeft = carousel.scrollLeft;
    carousel.classList.add("is-dragging");
    pause();
  });

  carousel.addEventListener("pointermove", (e) => {
    if (!isPointerDown) return;
    const dx = e.pageX - startX;
    if (Math.abs(dx) > 5) moved = true;
    carousel.scrollLeft = scrollLeft - dx;
  });

  const endDrag = () => {
    isPointerDown = false;
    carousel.classList.remove("is-dragging");
    setTimeout(resume, 1200);
  };

  carousel.addEventListener("pointerup", endDrag);
  carousel.addEventListener("pointerleave", endDrag);
  carousel.addEventListener("pointercancel", endDrag);

  carousel.querySelectorAll(".instagram-post").forEach((link) => {
    link.addEventListener("click", (e) => {
      if (moved) {
        e.preventDefault();
      }
    });
  });
}

function escapeHtml(str) {
  return String(str)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

function safeUrl(url, fallback) {
  if (!url || !String(url).startsWith("https://")) return fallback || "";
  return escapeHtml(url);
}